export enum TranscriptionDefaultFormFieldsName {
  STYLE = "style",
  FORMAT = "format",
  TRANSCRIPTION_LANGUAGE = "transcriptionLanguage",
  VISIT_RETENTION_PERIOD = "visitRetentionPeriod",
  VISIT_RETENTION_PERIOD_ID = "visitRetentionPeriodId",
}
